import { render, staticRenderFns } from "./HowtoPlayWindow.vue?vue&type=template&id=4ae2b474&scoped=true&"
import script from "./HowtoPlayWindow.vue?vue&type=script&lang=js&"
export * from "./HowtoPlayWindow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/windowAkawaku.css?vue&type=style&index=0&id=4ae2b474&prod&scoped=true&lang=css&"
import style1 from "./HowtoPlayWindow.vue?vue&type=style&index=1&id=4ae2b474&prod&scoped=true&lang=css&"
import style2 from "./HowtoPlayWindow.vue?vue&type=style&index=2&id=4ae2b474&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2b474",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VRow})
